import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "./constants";
import api, { baseUrl } from "../services/api";

export const useStudentDetails = (id) => {
  const queryKey = [QueryKey.StudentDetails, id];

  const queryFn = async () => {
    const URL = `${baseUrl}/students/${id}/details`;

    const { data } = await api.get(URL);

    return data;
  };

  return useQuery({
    queryKey: queryKey,
    queryFn: queryFn,
    enabled: !!id,
  });
};
